import { HStack, Tag, TagLabel } from '@chakra-ui/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const hardCodedTagsForFirstRelease = ['Business', 'Technology', 'Healthcare', 'People'];

interface SuggestedTagListProps {
  onTagClick: (value: string) => void;
}

export const SuggestedTagList = memo(({ onTagClick: onTagClickProp }: SuggestedTagListProps) => {
  const tags = hardCodedTagsForFirstRelease;
  const { t } = useTranslation('editor_widget_menu', { useSuspense: false, keyPrefix: 'sideMenu.photosMenu.tags' });

  const onTagClick = (value: string) => () => {
    onTagClickProp(value);
  };

  return (
    <HStack overflowX={'auto'} spacing={2} padding={2} paddingX={4} minHeight={12} data-testid='suggested-tags'>
      {tags.map((tag, index) => {
        return (
          <Tag
            key={index}
            as={'button'}
            size={'sm'}
            variant={'suggested-tag'}
            onClick={onTagClick(tag)}
            pointerEvents={'auto'}
          >
            <TagLabel>{t(tag as keyof typeof t)}</TagLabel>
          </Tag>
        );
      })}
    </HStack>
  );
});
SuggestedTagList.displayName = 'SuggestedTagList';
